import type { FaireProductEntity } from "../../entity_types/product";

export const p_hcnfc8e9wc: FaireProductEntity = {
  token: "p_hcnfc8e9wc",
  type: "product",
  name: "Gold Delicate Rhinestone Stud Open Ring",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl:
    "https://cdn.faire.com/fastly/1e88024fe2a4d888ab778cb6ec7bf1d9754dceb935604982b8b9279c7eded44d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84b062e39810eb7adac9aa3ee1528943adac375b27e6792ca65d613304dad577.jpeg",
  ],
  priceDollars: 3.05,
  description:
    "Luxury Rhinestone Design\nGold Open Ring\nAdjustable\nRing Diameter 2CM",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:22.434Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
